import QRCodeStyling from 'qr-code-styling';
import { addCanvasImage } from '~core/image/addCanvasImage';
import { uploadQrCode } from '~src/sidebar/qr';

export const generateQrCode = async (userQrFormInput) => {
  const qrCode = await new QRCodeStyling({
    width: 250,
    height: 250,
    data: userQrFormInput,
    dotsOptions: {
      color: '#000000',
      type: 'extra-rounded',
    },

    cornersSquareOptions: {
      type: 'extra-rounded',
      color: '#000000',
    },

    backgroundOptions: {
      color: '#ffffff',
    },
  });

  const qrBlob = await qrCode.getRawData();

  const qrCodeUrl = await uploadQrCode(qrBlob);

  return addCanvasImage(qrCodeUrl);
};
